import * as types from "../../actions/types";

const initialState = {
  success: false,
  err: ''
}

export default function deleteAdsReducer(state = initialState, action) {
  switch (action.type) {
    case types.DELETE_ADS:
      return {
        ...state,
        succes: action.succes
      }
    case types.DELETE_ADS_ERR:
      return {
        ...state,
        err: action.err
      }
    default:
      return state
  }
}